import React from 'react'
import { makeStyles, Grid, Typography, Chip, Link } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#211A29',
    padding: '80px 20px',
    margin: 'auto',
    [theme.breakpoints.up('sm')]: {
      padding: '80px 120px',
    },
  },
  header: {
    color: 'white',
    margin: '1rem 0',
    letterSpacing: '-0.02em',
    [theme.breakpoints.down('sm')]: {
      fontSize: '52px',
    },
  },
  chip: {
    background: 'rgba(11, 11, 11, 0.8)',
    color: 'white',
  },
  link: {
    color: 'white',
    fontSize: '.8rem',
    padding: '.4rem 0',
    borderBottom: '1px solid white',
  },
  contentSection: {
    margin: '1rem 0',
    '& p': {
      color: 'white',
    },
  },
  contentCard: {
    padding: '1rem',
    background: 'rgba(255, 255, 255, 0.06)',
    borderRadius: '.4rem',
  },
  cardBody: {
    fontSize: '1rem',
  },
  cardHeader: {
    margin: '0 0 1rem 0',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
}))

export default function ExchangeGuide(): JSX.Element {
  const classes = useStyles({})
  return (
    <div className={classes.root}>
      <Chip label="Exchange guide" className={classes.chip} />
      <Typography variant="h1" className={classes.header}>
        How to choose the right decentralized exchange
      </Typography>
      <Link className={classes.link} underline="none">
        See the whole guide
      </Link>
      <div>
        <Grid container className={classes.contentSection} spacing={2} wrap="wrap">
          <Grid item xs={12} sm={3}>
            <div className={classes.contentCard}>
              <Typography variant="body2" className={classes.cardHeader}>
                Available tokens
              </Typography>
              <Typography variant="body2" className={classes.cardBody}>
                Decentralized exchanges differ a lot in how many tokens are traded on them and how
                much liquidity there is for each token. Some decentralized exchanges are more
                popular than others so they attract more trading activity.
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.contentCard}>
              <Typography variant="body2" className={classes.cardHeader}>
                Fees
              </Typography>
              <Typography variant="body2" className={classes.cardBody}>
                The fees you pay don’t go to a company but to the Liquidity providers on the
                decentralized exchange platform. The amount is set by the protocol varying between
                0.2 -1%. Transaction fees you pay to the network validators are another cost factor.
                Some exchanges have lower transaction fees due to how their contracts are built.
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.contentCard}>
              <Typography variant="body2" className={classes.cardHeader}>
                Liquidity
              </Typography>
              <Typography variant="body2" className={classes.cardBody}>
                The level of liquidity on an exchange affects the cost at which you can execute
                trades without moving the market. If there&apos;s a high level of liquidity your
                purchase won’t have a large impact on the price.
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.contentCard}>
              <Typography variant="body2" className={classes.cardHeader}>
                Features
              </Typography>
              <Typography variant="body2" className={classes.cardBody}>
                A good decentralized exchange should be simple to use with a pleasing user interface
                and some advanced features like limit orders, availability on different Layer-2
                networks, community support in reach and more.
              </Typography>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}
